import { useState } from "react";
import { Bookmark } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { api, formatApiError } from "@/lib/api";

export const SaveSearchButton = ({ params, suggestedName }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState(false);
  const [busy, setBusy] = useState(false);
  const empty = !Object.keys(params).length;
  const save = async () => {
    setBusy(true);
    try {
      const r = (await api.post("/saved-searches", { name, params, email_alerts: email })).data;
      toast.success(`Saved "${r.name}". ${r.match_count} players match today; we'll alert you about new ones.`);
      setOpen(false);
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <>
      <button data-testid="save-search-button" disabled={empty} onClick={() => { setName(suggestedName); setOpen(true); }}
        title={empty ? "Pick a filter first" : "Save this search"}
        className="flex h-14 items-center gap-2 rounded-xl border border-slate-800 bg-[#131927] px-4 text-sm transition-colors duration-200 hover:border-[#FF2D78] disabled:opacity-40">
        <Bookmark className="h-4 w-4" /> <span className="hidden sm:inline">Save search</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="border-slate-800 bg-[#131927]">
          <DialogHeader><DialogTitle className="font-display text-2xl uppercase">Save search</DialogTitle></DialogHeader>
          <input data-testid="save-search-name-input" value={name} onChange={(e) => setName(e.target.value)} maxLength={80}
            className="h-11 w-full rounded-lg border border-slate-700 bg-[#0B0F19] px-3 text-sm text-white outline-none focus:border-[#FF2D78]" />
          <label className="flex items-center justify-between gap-4 text-sm text-slate-300">
            <span>Email me when new players match
              <span className="block text-xs text-slate-500">You'll always get an alert under the bell in the header.</span></span>
            <Switch data-testid="save-search-email-toggle" checked={email} onCheckedChange={setEmail} />
          </label>
          <DialogFooter>
            <button data-testid="save-search-confirm" onClick={save} disabled={busy || !name.trim()}
              className="rounded-full bg-[#FF2D78] px-5 py-2 text-sm font-semibold text-white hover:bg-[#E01F66] disabled:opacity-50">Save</button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
